import { Link, useParams } from 'react-router-dom'
import { FinalCta } from '../components/FinalCta'
import { PageHero } from '../components/PageHero'
import { Seo } from '../components/Seo'
import { business } from '../config/business'
import { serviceById } from '../data/services'
import { NotFoundPage } from './NotFoundPage'

export function ServiceDetailPage() {
  const { serviceId = '' } = useParams()
  const service = serviceById(serviceId)
  if (!service) return <NotFoundPage />

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: service.name,
    description: service.summary,
    provider: { '@type': 'Notary', name: business.name, url: business.siteUrl },
    areaServed: 'Northwest Arkansas',
  }

  return (
    <>
      <Seo title={`${service.name} in Northwest Arkansas`} description={`${service.summary} Learn pricing, who the service is for, and what to expect.`} path={`/services/${service.id}`} schema={schema} />
      <PageHero eyebrow={service.eyebrow} title={service.name} intro={service.summary}>
        <Link className="button" to="/request-appointment">Request this service</Link>
        <Link className="button button-secondary" to="/pricing">Review pricing</Link>
      </PageHero>
      <section className="section service-detail-section">
        <div className="container service-detail-grid">
          <article>
            <span className="eyebrow">The service</span>
            <h2>Professional support with a clear scope.</h2>
            <p className="lead">{service.overview}</p>
            {service.caution && <div className="notice-card"><strong>Important</strong><p>{service.caution}</p></div>}
            <h2>What to expect</h2>
            <ol className="expectation-list">{service.expectations.map((item, index) => <li key={item}><span>{index + 1}</span><p>{item}</p></li>)}</ol>
          </article>
          <aside>
            <div className="detail-sidebar-card"><span className="eyebrow">Starting price</span><strong>{service.pricingSummary}</strong><p>Final service and travel fees will be confirmed before the appointment is scheduled.</p><Link className="button button-full" to="/pricing">Estimate your total</Link></div>
            <div className="detail-sidebar-card"><h2>Common clients</h2><ul className="simple-list">{service.audience.map((audience) => <li key={audience}>{audience}</li>)}</ul></div>
          </aside>
        </div>
      </section>
      <section className="section legal-reminder"><div className="container narrow"><span className="eyebrow">Clear professional boundaries</span><h2>Notary service is not legal advice.</h2><p>{business.legalDisclaimer}</p></div></section>
      <FinalCta title={`Request ${service.shortName.toLowerCase()} service`} />
    </>
  )
}
